var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPopupDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-690 -7598) translate(0 6947) translate(690 651)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#FDE8EA"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F11D2D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.909 18.586H16.914l12.089-11.99c.668-.662.668-1.736 0-2.399L25.94 1.16c-1.558-1.545-4.085-1.545-5.643 0l-3.15 3.124-1.612-1.6c-1.777-1.762-4.67-1.762-6.448 0L2.799 8.92c-1.778 1.764-1.778 4.633 0 6.396l1.612 1.6-3.15 3.123c-1.557 1.546-1.557 4.051 0 5.597l3.064 3.038c.668.662 1.75.662 2.418 0l4.334-4.299V50.54c0 4.06 3.318 7.35 7.41 7.35H36.5c4.092 0 7.41-3.29 7.41-7.35V18.586zm-37.08-4.07l-1.611-1.598c-.445-.441-.445-1.158 0-1.6l6.287-6.236c.445-.44 1.168-.44 1.612 0l1.612 1.6-7.9 7.835zm14.766 33.875c0 .937-.765 1.696-1.71 1.696-.944 0-1.71-.76-1.71-1.696V28.084c0-.937.766-1.696 1.71-1.696.945 0 1.71.759 1.71 1.696V48.39zm7.608 0c0 .937-.766 1.696-1.71 1.696s-1.71-.76-1.71-1.696V28.084c0-.937.766-1.696 1.71-1.696s1.71.759 1.71 1.696V48.39zm7.608 0c0 .937-.766 1.696-1.71 1.696-.945 0-1.71-.76-1.71-1.696V28.084c0-.937.765-1.696 1.71-1.696.944 0 1.71.759 1.71 1.696V48.39z",
    transform: "translate(27 26)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.398 12.838c-1.043.36-1.775 1.284-1.896 2.356h16.407v-2.819c0-1.935-1.92-3.297-3.764-2.677l-10.712 3.128-.035.012z",
    transform: "translate(27 26)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupDelete);
export default __webpack_public_path__ + "static/media/popup-delete.8389f7767bccbbe90bb8f595af9cf373.svg";
export { ForwardRef as ReactComponent };